"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachCompany = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var attachModalEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('selected', 'setSelected', null), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (!this.props.isOpen && prevProps.isOpen) {
            this.props.setSearchString('');
            this.props.setSelected(null);
            this.props.clearManagementModals();
        }
    }
}), recompose_1.pure);
exports.AttachCompany = attachModalEnhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sso-management-attach-company' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.setIsOpen(false); } }, (0, translation_1.getLocalization)('sso/management/attach/company/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.attachCompanyStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/attach/creating')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/attach/created')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/attach/failed'))),
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            (0, translation_1.getLocalization)("sso/management/attach/company/searchString"),
                            ":")),
                    React.createElement("td", null,
                        React.createElement(sok_ui_1.Dropdown2, null,
                            React.createElement(sok_ui_1.TextInput, { value: props.searchString, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-search' }), iconRight: props.companySearchStatus === 'FETCHING' ? (React.createElement(sok_ui_1.Icon, { className: 'fa-spinner fa-spin' })) : undefined, onChange: function (e) {
                                    props.setSearchString(e.target.value);
                                    props.searchCompanies(e.target.value);
                                } }),
                            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sso-management-attach-company-search-result' }, props.companySearch.map(function (x) { return (React.createElement("div", { onClick: function () {
                                    props.setSelected(x);
                                    props.setSearchString(x.name);
                                } },
                                x.name,
                                " (",
                                x.id,
                                ")")); }))))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.attachCompanyStatus === 'FETCHING' || props.selected === null, text: (0, translation_1.getLocalization)('userfront/button/save'), onClick: function () {
                    return props.selected && props.attachCompany(props.sso, props.selected);
                } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () { return props.setIsOpen(false); } }))));
});
